import { CrudManager } from "./CrudManager";

export default function AdminBlog() {
  return (
    <CrudManager
      testidPrefix="admin-blog"
      title="Blog Posts"
      description="Publish health articles and hospital news."
      endpoint="/admin/blog"
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "author", label: "Author" },
        { key: "published", label: "Published" },
      ]}
      renderCell={(key, it) => {
        if (key === "published") return it.published ? <span className="text-red-700 font-medium">Yes</span> : <span className="text-slate-400">Draft</span>;
        return it[key];
      }}
      emptyValues={{ title: "", category: "Health Tips", excerpt: "", content: "", cover_image: "", author: "Afzal Medical Team", published: true }}
      fields={[
        { name: "title", label: "Title", type: "text" },
        { name: "category", label: "Category", type: "text" },
        { name: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
        { name: "content", label: "Content", type: "textarea", rows: 10 },
        { name: "cover_image", label: "Cover image URL", type: "url" },
        { name: "author", label: "Author", type: "text" },
        { name: "published", label: "Publish immediately", type: "checkbox" },
      ]}
    />
  );
}
